export const literalDuration = (duration: number) => {
	const hours = Math.floor(duration / 60);
	const minutes = duration % 60;

	const getHours = (hours: number) => {
		if (hours) {
			if ((hours >= 2 && hours <= 4) || (hours >= 22 && hours <= 24)) {
				return `${hours} часа`;
			} else if (hours === 1 || hours === 21) {
				return `${hours} час`;
			} else {
				return `${hours} часов`;
			}
		} else {
			return '';
		}
	};

	const getMinutes = (minutes: number) => {
		if (minutes) {
			if (minutes % 10 >= 2 && minutes % 10 <= 4) {
				return `${minutes} минуты`;
			} else if (minutes % 10 === 1) {
				return `${minutes} минута`;
			} else {
				return `${minutes} минут`;
			}
		} else {
			return '';
		}
	};

	return `${getHours(hours)} ` + `${getMinutes(minutes)}`;
};
